import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { useNavigate, useSearchParams } from "react-router-dom";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import PersonIcon from "@mui/icons-material/Person";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import BlogCards from "./BlockCards";
import Testimonials from "./sapcontent/Testimonials";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import BookDemoForm from "../../allClasses/BookDemoForm";
import ConfimationPopup from "../../../components/customPopup/ConfimationPopup";
import GlobalMessageModal from "../../../components/customPopup/GlobalMessageModal";
import ArticleIcon from "@mui/icons-material/Article";
import DashboardBlogs from "../dashboardComp/dashboardBlogs/DashboardBlogs";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function TestTypeContent({}) {
  const [testTypeContent, setTestTypeContent] = useState({});
  const [testDetails, setTestDetails] = useState(null);
  const [searchParams] = useSearchParams();
  const testName = searchParams.get("test"); // This will get the value from ?test=...
  const [examPatterndata, setExamPatternData] = useState([]);
 const [openBookDemo, setOpenBookDemo] = useState(false);
   const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
const [testTypeId, setTestTypeId] =useState(null)
const navigate =useNavigate()

  // find passed test data
  useEffect(() => {
    const storedData = localStorage.getItem("testDetails");
    if (storedData) {
      setTestDetails(JSON.parse(storedData));
    }
  }, []);

  // getExam Pattern Data

  const fetchTestPrepSubservices = async () => {
    const formData = {
      test_type_id: testDetails?.id,
      test_delivery_format: null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}stm-route/get-exam-pattern`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setExamPatternData(data);
      } else {
        console.error("internal server error");
      }
    } catch (err) {
      console.error("internal server error", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchTestPrepSubservices();
  }, [testDetails]);

  // testContentConfig.js

  useEffect(() => {
    switch (testName) {
      case "GRE":
        setTestTypeContent({
          title: "GRE",
          shortName: "GRE",
          description:
            "The Graduate Record Examination (GRE) is a standardized, computer-based, multiple-choice exam often required for admission to graduate, global MBA, and specific law programs, particularly for those planning tostudy internationally. Developed and administered by ETS, the GRE provides a common measure for graduate, business, and law schools to compare applicants' qualifications and preparedness for advanced academic work.",

          why: {
            title: "Why do you need GRE?",
            content:
              "The GRE exam is essential for students and professionals aspiring to pursue graduate and postgraduate studies abroad. It evaluates verbal reasoning, quantitative reasoning, analytical writing, and critical thinking skills—key for success in master’s and doctoral programs. A strong GRE score strengthens your application, demonstrates academic readiness, and boosts your chances of admission to top universities and business schools across the USA, UK, Canada, Australia, and Europe",
          },

          examPatternTitle: "Exam Pattern",

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },
          tipsTitle: "Tips to score",
          titpsheading: "Tips to get 8 + bands in GRE",
          tips: [
            "Testing Portal",
            "Practice Material",
            "Vocabulary Kit",
            "Get access to customized Material, Feedback",
            "Doubt Clearing",
            "Video lessons",
            "Vocabulary Kit",
            "Certified trainers & smart classes & Many More",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "Most candidates spend 2 to 4 months preparing. This may vary depending on the test taker’s math and verbal reasoning skills",
            },
            {
              question: "Is there live support ?",
              answer: "Yes, It is Available via our online platform.",
            },
            {
              question: "Can I check my GRE test results online ?",
              answer:
                "You’ll see unofficial verbal and quant scores right after the test. Full scores are available online in 10–15 days.",
            },
            {
              question: "Who sets the pass mark for the GRE test ?",
              answer:
                "The test has no official passing score. Each graduate program sets its own target score",
            },
            {
              question: "What is the difference between gmat and gre?",
              answer:
                "The GRE is a general graduate admission test accepted for various programs like MS and PhD, while the GMAT is specifically for MBA and business school admissions.",
            },
          ],
        });
        break;
      case "GMAT":
        setTestTypeContent({
          title: "GMAT",
          shortName: "GMAT",
          description:
            "The Graduate Management Admission Test (GMAT) is a standardized, computer-based exam required by most graduate business programs, such as the MBA and MS in Management. Administered by the Graduate Management Admission Council (GMAC), the test evaluates a candidate's quantitative, verbal, and data analysis abilities. Its structure is specifically designed to predict a student's readiness for the rigorous curriculum of business school.",
          why: {
            title: "Why do you need GMAT?",
            content:
              "The GMAT exam is essential for students and professionals aiming to pursue management and business-related studies abroad. It evaluates analytical writing, integrated reasoning, quantitative, and verbal skills—crucial for success in MBA and other business programs. A strong GMAT score enhances your application, demonstrates your problem-solving ability, and opens opportunities at top business schools and universities across the USA, UK, Canada, Australia, and Europe.",
          },

          examPatternTitle: "Exam Pattern",

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },
          tipsTitle: "Tips to score",
          titpsheading: "Tips to get 8+ bands in GRE",
          tips: [
            "Video Lessons",
            "One-to-one doubt sessions",
            "Fully software based practice",
            "Customized study material with practice questions",
            "Feedback from certified trainers",
            "Mock test, module tests and question-wise tests & Many More",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "A dedicated study plan of 2 to 3 months is common. However, higher scores may require up to 6 months of focused prep",
            },
            {
              question: "Is there live support ?",
              answer:
                "Official support is available for test logistics, but live learning comes through prep platforms and tutors",
            },
            {
              question: "Can I check my GMAT test results online ?",
              answer:
                "Unofficial scores are shown immediately after the test. Official scores appear in your account within about 7 days",
            },
            {
              question: "Who sets the pass mark for the GMAT test ?",
              answer:
                "There’s no pass or fail. Business schools decide what score range is competitive for admission.",
            },
            {
              question: "what is the difference between gmat and gre?",
              answer:
                "The GRE is a general graduate admission test accepted for various programs like MS and PhD, while the GMAT is specifically for MBA and business school admissions",
            },
          ],
        });
        break;
      case "SAT":
        setTestTypeContent({
          title: "SAT",
          shortName: "SAT",
          description:
            "The SAT, or Scholastic Assessment Test, is a standardized test widely used for college admissions in the United States. It's a multiple-choice, computer-based test administered by the College Board. The SAT aims to assess a high school student's readiness for college and provides a common data point for admissions decisions. ",
          why: {
            title: "Why do you need SAT?",
            content:
              "The SAT exam is essential for students planning to pursue undergraduate studies abroad. It evaluates evidence-based reading, writing, and mathematics—key skills for academic success in universities. A strong SAT score strengthens your college application, highlights your academic readiness, and opens opportunities at leading universities and colleges across the USA, UK, Canada, Australia, and Europe.",
          },

          examPatternTitle: "Exam Pattern",

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },
          tipsTitle: "Tips to score",
          titpsheading: "Tips to get 8 + bands in SAT",
          tips: [
            "Video Lessons",
            "Vocabulary Kit",
            "Fully software based practice",
            "Mock tests with real exam interface  & Many More",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "Preparation time can range from 2 to 6 months, depending on the student's academic background and score goals.",
            },
            {
              question: "Is there live support ?",
              answer: "Yes, It is Available via our online platform.",
            },
            {
              question: "Can I check my SAT test results online ?",
              answer:
                "Yes, SAT scores are posted online about two weeks after the test date, accessible via the College Board portal",
            },
            {
              question: "Who sets the pass mark for the SAT test ?",
              answer:
                "The SAT doesn’t have a pass mark. Colleges set their own required or average score ranges for admission.",
            },
            {
              question: "How many times can I take the SAT?",
              answer:
                "You can take the SAT as many times as you like. Most students take it 2–3times to improve their scores.",
            },
          ],
        });

        break;
      case "IELTS":
        setTestTypeContent({
          title: "IELTS",
          shortName: "IELTS",
          description:
            "The IELTS exam measures a student’s ability to use English effectively. It is widely recognized and essential for non-native speakers, as well as those whose previous studies were not in English.",
          versiondescription: "There are two versions of the IELTS test:",
          versions: [
            {
              type: "IELTS Academic",
              details:
                "This version is meant for students aiming to study in English-speaking countries. The passages and questions are usually drawn from academic textbooks, journals, and research articles.",
            },
            {
              type: "IELTS General Training",
              details:
                "This version is for individuals applying for permanent residency (PR) or a work visa. The focus is on everyday English, with topics based on daily conversations and practical, real-life situations.",
            },
          ],
          why: {
            title: "Why do you need IELTS?",
            content:
              "The IELTS exam is essential for students and professionals aiming to study, work, or migrate abroad. It helps prove English language proficiency, especially for non-native speakers or those whose previous education was not in English. A strong IELTS score opens opportunities in universities, jobs, and immigration across countries like the UK, USA, Canada, Australia, and more.",
          },

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },

          tipsTitle: "Resources & Tips",
          resourcesHeading: "Resources",
          resources: ["Practice Tests ", "Video Lessons", "Downloadable PDFs"],

          titpsheading: "Preparation Tips",
          tips: [
            "Smart study plans ",
            "Time Management Hacks",
            "Common Mistakes To Avoid",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "Most students complete IELTS preparation in 1 to 3 months. Duration depends on your current English level and whether you take an intensive or part-time course.",
            },
            {
              question: "Is there live support ?",
              answer: "Yes, It is Available via our online platform.",
            },
            {
              question: "Can I check my IELTS test results online ?",
              answer:
                "Yes, results are available online 13 days after the test.",
            },
            {
              question: "Who sets the pass mark for the IELTS test ?",
              answer:
                "There is no official pass or fail. Each university, immigration office, or organization sets its own minimum score requirement",
            },
            {
              question:
                "How is IELTS better than other English Language tests available ?",
              answer:
                "IELTS is one of the most widely accepted tests globally, especially in the UK, Canada, Australia, and New Zealand. It’s known for its real-life communication focus and paper or computer-based flexibility",
            },
          ],
        });

        break;

      case "PTE":
        setTestTypeContent({
          title: "PTE",
          shortName: "PTE",
          description:
            "PTE (Pearson Test of English Academic) is required if you plan to study abroad, migrate, or apply for a work permit. It is a computer-based English test that checks whether you can communicate effectively in English in real-life situations. PTE is widely accepted by universities, colleges, and governments across the world, including Australia, New Zealand, the UK, Canada, and many more",
          versiondescription: "There are two versions of the PTE test:",
          versions: [
            {
              type: "PTE Academic",
              details:
                "For students applying to universities and colleges abroad. It focuses on academic English and is accepted for both study and migration.",
            },
            {
              type: "PTE Core",
              details:
                "For those applying for Permanent Residency (PR) or work visas, especially in Canada. The test checks everyday English skills needed to live and work overseas.",
            },
          ],
          why: {
            title: "Why do you need PTE?",
            content:
              "The PTE Academic exam is essential for students and professionals planning to study, work, or migrate abroad. It assesses real-life English skills through integrated tasks and is widely accepted by universities, governments, and employers across the world. A strong PTE score proves your ability to communicate effectively in English and opens opportunities in top destinations like the UK, USA, Canada, Australia, and New Zealand.",
          },

          examPatternTitle: "Exam Pattern",

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },

          tipsTitle: "Resources & Tips",
          resourcesHeading: "Resources",
          resources: [
            "Fully software based practice. ",
            "Vocabulary kit for high-scoring words.",
            "Mock test, module tests and question-wise tests will be provided",
            "Sample essays and summarized text answers    & Many More",
          ],

          titpsheading: "Tips to get 8 + bands in PTE",
          tips: [
            "Practice daily speaking for fluency & pronunciation. ",
            "Take AI mock tests to track performance.",
            "Strengthen time management (PTE is fast-paced)",
            "Build vocabulary for academic   & many More",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "Preparation typically takes 4 to 6 weeks. Fast learners or those with a strong English foundation may require less time.",
            },
            {
              question: "Is there live support ?",
              answer: "Yes, It is Available via our online platform.",
            },
            {
              question: "Can I check my PTE test results online ?",
              answer:
                "Yes, results are typically available within 1 to 2 business days through your Pearson account",
            },
            {
              question: "Who sets the pass mark for the PTE test ?",
              answer:
                "No fixed pass mark exists. Your score must meet the criteria set by the institution or authority you’re applying to.",
            },
            {
              question:
                "How is PTE better than other English Language tests available ?",
              answer:
                "PTE is fully computer-based with AI scoring, making it fast and consistent. It’s especially popular for Australian visa applications and offers quick result delivery",
            },
          ],
        });

        break;

      case "TOEFL":
        setTestTypeContent({
          title: "TOEFL",
          shortName: "TOEFL",
          description:
            "TOEFL (Test of English as a Foreign Language) is an international English language test designed to measure your ability to communicate effectively in English, especially in academic settings. It is accepted by 11,500+ universities and institutions in 160+ countries, including the USA, Canada, Australia, and the UK.",
          versiondescription: "There are two versions of the TOEFL test:",
          versions: [
            {
              type: "TOEFL iBT (Internet-based Test) –",
              details:
                " The most common version, taken on a computer at test centers or at home (TOEFL Home Edition).",
            },
            {
              type: "TOEFL iBT Paper Edition – ",
              details:
                "A paper-based version (available in select countries), but still requires a computer for the Speaking section.",
            },
          ],
          why: {
            title: "Why do you need TOEFL?",
            content:
              "The TOEFL exam is essential for students and professionals planning to study, work, or migrate abroad. It evaluates reading, listening, speaking, and writing skills—crucial for success in academic and professional settings. A strong TOEFL score demonstrates your English proficiency, strengthens your application, and opens doors to leading universities and institutions across the world, especially in the USA, UK, Canada, Australia, and Europe.",
          },

          examPatternTitle: "Exam Pattern",

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },
          tipsTitle: "Resources & Tips",
          resourcesHeading: "Resources",
          resources: [
            "Customized study material for each level. ",
            "Practice worksheets for speaking and grammar.",
            "Role-play activities for real-life situations",
            "One-to-one feedback sessions with trainers & Many More",
          ],

          titpsheading: "Tips to Improve Your English Spoken",
          tips: [
            "Focus on fluency first, then accuracy. ",
            "Learn 5–10 new words every day and use them in sentences.",
            "Listen to English news, podcasts, and movies to pick up expressions.",
            "Practice with a partner or join group discussions & many More.",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "On average, students prepare for 1 to 3 months. Some may need more time if they are not familiar with academic English",
            },
            {
              question: "Is there live support ?",
              answer:
                "ETS provides technical support and resources, while live classes are available through third-party tutoring services.",
            },
            {
              question: "Can I check my TOEFL test results online ?",
              answer:
                "Yes, you can view your scores online 6–10 days after the test via your ETS account.",
            },
            {
              question: "Who sets the pass mark for the TOEFL test ?",
              answer:
                "ETS doesn’t set a pass score. Schools and other organizations define the minimum acceptable score based on their standards",
            },
            {
              question:
                "How is TOEFL better than other English Language tests available ?",
              answer:
                "Highly regarded by U.S. and Canadian institutions, TOEFL tests academic English and is preferred for university admissions worldwide.",
            },
          ],
        });
        break;
      case "DUOLINGO":
        setTestTypeContent({
          title: "DUOLINGO",
          shortName: "DUOLINGO",
          description:
            "The Duolingo English Test (DET) is an English proficiency exam that you can take from home using your computer, webcam, and internet. It is accepted by thousands of universities and colleges around the world, making it a convenient, affordable, and widely recognized alternative to traditional tests.",
          versiondescription: null,
          versions: [],
          why: {
            title: "Why do you need Duolingo?",
            content:
              "The Duolingo English Test is essential for students planning to pursue studies abroad. It evaluates reading, writing, listening, and speaking—key skills for academic success in universities. A strong Duolingo score strengthens your college application, highlights your English proficiency, and opens opportunities at leading universities and colleges across the USA, UK, Canada, Australia, and Europe.",
          },

          examPatternTitle: "Exam Pattern",

          totalInfo: {
            text: "Total 55 Questions | 118 Minutes",
            icon: "/newdashboard/Group 1171282773.png",
          },

          tipsTitle: "Tips to score",
          titpsheading: "Tips to score 120 bands in Duolingo",
          tips: [
            "Speak clearly and practice daily. ",
            "Build vocabulary for common topics.",
            "Get comfortable with adaptive-style questions.",
            "Manage time carefully during the test.",
            "Record yourself while practicing speaking",
            "Revise grammar basics to avoid mistakes & Many More",
          ],
          faqs: [
            {
              question: "How Long is this course ?",
              answer:
                "Since the test is shorter and less complex, 2 to 4 weeks of preparation is often enough for those already proficient in English",
            },
            {
              question: "Is there live support ?",
              answer: "Yes, it is available on our platform.",
            },
            {
              question: "Can I check my Duolingo test results online ?",
              answer:
                "Yes, you’ll receive your results within 48 hours, delivered via email and viewable in your account.",
            },
            {
              question: "Who sets the pass mark for the Duolingo test ?",
              answer:
                "There is no standard pass mark. Institutions choose their own acceptable score levels for admission",
            },
            {
              question:
                "How is Duolingo better than other English Language tests available ?",
              answer:
                "A modern, affordable, and fast English test. It can be taken from home and delivers results within 2 days, with growing acceptance worldwide",
            },
          ],
        });

        break;

      case "SPOKEN ENGLISH":
        setTestTypeContent({
          title: "SPOKEN ENGLISH",
          shortName: "SPOKEN ENGLISH",
          description:
            "English is the global language and one of the most important skills for education, career, and daily life. Whether you want to study abroad, apply for a job, or simply improve your communication skills, Spoken English is the key to expressing yourself confidently. our Spoken English Program is designed for learners of all levels — from beginners to advanced — and focuses on fluency, pronunciation, vocabulary, and grammar. The program helps you build confidence in real-life conversations, professional discussions, and academic communication.",

          versiondescription: null,
          versions: [],
          why: {
            title: "Why do you need Spoken English?",
            content:
              "Spoken English is essential for students and professionals aiming to improve communication skills for academics, careers, and daily life. It focuses on fluency, vocabulary, grammar, and pronunciation—key abilities for confident interaction in universities, workplaces, and social settings. Strong spoken English enhances your personality, builds confidence, and opens opportunities across countries like the USA, UK, Canada, Australia, and Europe.",
          },

          examPatternTitle: "Exam Pattern",

          course_structure: [
            {
              name: "Basic Level",
              features: [
                "Build confidence, self-introduction",
                "Focus on everyday conversations",
                "Learn sentence, grammar & vocabulary",
              ],
            },
            {
              name: "Intermediate Level",
              features: [
                "Group discussion & story-telling",
                "Build confidence & self-introduction",
                "Learn formal & informal communication",
              ],
            },
            {
              name: "Advanced Level",
              features: [
                "Vocabulary & Polish Pronunciation",
                "Presentations, Interviews & Speaking",
                "Professional & Academic Communication",
              ],
            },
          ],

          tipsTitle: "Resources & Tips",
          resourcesHeading: "Resources",
          resources: [
            "Customized study material for each level ",
            "Practice worksheets for speaking and grammar",
            "Role-play activities for real-life situations",
            "One-to-one feedback sessions with trainers    & Many More",
          ],

          titpsheading: "Tips to Improve Your English Spoken",
          tips: [
            "Focus on fluency first, then accuracy ",
            "Learn 5–10 new words every day and use them in sentences.",
            "Listen to English news, podcasts, and movies to pick up expressions.",
            "Practice with a partner or join group discussions.   & many More",
          ],
          faqs: [
            {
              question: "Who is this Spoken English course designed for?",
              answer:
                "This course is ideal for learners of all levels — from beginners to advanced — who want to improve their fluency, pronunciation, vocabulary, and confidence in everyday and professional communication.",
            },
            {
              question: "What topics and skills will I learn in this course?",
              answer:
                "You’ll focus on fluency, grammar, vocabulary, pronunciation, self-introduction, conversation skills, storytelling, presentations, interviews, and professional communication.",
            },
            {
              question: "How is the course structured?",
              answer:
                "The course is divided into three levels: Basic (confidence-building and everyday conversations), Intermediate (group discussions and storytelling), and Advanced (professional presentations and academic communication)",
            },
            {
              question:
                "Are there any practice sessions or speaking activities included?",
              answer:
                "Yes, the course includes role-play activities, practice worksheets, and one-to-one feedback sessions to help you practice real-life conversations and improve your speaking skills.",
            },
            {
              question:
                "How long does the Spoken English course take to complete?",
              answer:
                "Duration varies depending on your level and pace, but typically it takes 1 to 3 months with regular practice.",
            },
          ],
        });

        break;

      // Spoken English
    }
  }, [testDetails]);

  // why choose us data
  const features = [
    {
      title: "Expert Tutors",
      description:
        "Learn from certified GRE trainers with years of experience.",
    },
    {
      title: "Flexible Learning",
      description: "Access materials anytime, anywhere on web or mobile.",
    },
    {
      title: "Proven Results",
      description: "Thousands of students have achieved their dream scores.",
    },
  ];


  // Book Demo
  const handleOpenBookDemo = (testId) => {
    setOpenBookDemo(true);
    setTestTypeId(testId)
  };

  const handleCloseBookDemo = () => {
    setOpenBookDemo(false);
  };

    const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

const handleNavigateToClass = (testId) => {
  navigate('/test-prep/classes', {
    state: { testTypeId: testId },
  });
};

  return (
    <>
      <GlobalCard>
        <Grid container spacing={4} p={4}>
          {/* Top Section */}
          <Grid item xs={12}>
            <Grid container spacing={4} alignItems="center">
              {/* Left Content */}
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      fontSize="32px"
                      fontFamily="Inter"
                      fontWeight={400}
                      color="#572575"
                    >
                      {testTypeContent?.title}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      fontSize="16px"
                      fontFamily="Inter"
                      fontStyle="normal"
                      fontWeight={400}
                      gutterBottom
                      color="#555555"
                    >
                      {testTypeContent?.description}
                    </Typography>
                  </Grid>

                  {testTypeContent?.versiondescription && (
                    <Grid item xs={12}>
                      <Typography
                        fontSize="18px"
                        fontWeight={400}
                        sx={{ mt: 3 }}
                        color="#000000"
                      >
                        {testTypeContent?.versiondescription}
                      </Typography>
                    </Grid>
                  )}

                  {testTypeContent?.versions?.map((item, index) => (
                    <Grid item xs={12}>
                      <Typography
                        key={index}
                        variant="body1"
                        gutterBottom
                        sx={{ mt: 1 }}
                      >
                        <b>{item.type} –</b>{" "}
                        <span color="#555555">{item.details} </span>
                      </Typography>
                    </Grid>
                  ))}

                  <Grid item xs={12} mt={4} container gap={2}>
                    <Button
                      variant="contained"
                      startIcon={<PersonIcon />}
                    onClick={()=>handleNavigateToClass(testDetails?.id)}
                      style={{
                        background: "#572575",
                        fontWeight: "600",
                        borderRadius: "8px",
                        fontSize: "12px",
                        paddingLeft: 20,
                        paddingRight: 20,
                        // py: 1.2,
                      }}
                    >
                      Enroll Now
                    </Button>

                    <Button
                      variant="outlined"
                      startIcon={<LaptopMacIcon />}
                     onClick={() => handleOpenBookDemo (testDetails?.id) }
                      sx={{
                        borderRadius: "8px",
                        border: "1px solid #E7CEF6", // purple border
                        color: "#572575", // purple text
                        fontWeight: "600",
                        fontSize: "12px",
                        textTransform: "none",
                        boxShadow: "0 0 8px rgba(156, 39, 176, 0.3)", // purple glow
                        "&:hover": {
                          backgroundColor: "rgba(156, 39, 176, 0.05)",
                          borderColor: "#E7CEF6",
                        },
                      }}
                    >
                      Book Demo
                    </Button>
                  </Grid>

                  <Box>
                    <Typography
                      fontSize="22px"
                      fontWeight={400}
                      fontFamily="Inter"
                      fontStyle="normal"
                      sx={{ mt: 5, mb: 1 }}
                      color="#572575"
                    >
                      {testTypeContent?.why?.title}
                    </Typography>
                    <Typography
                      fontStyle="normal"
                      color="#555555"
                      fontSize="16px"
                      fontWeight={400}
                      fontFamily="Inter"
                    >
                      {testTypeContent?.why?.content}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              {/* Right Side Image */}
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    // bgcolor: "#8b4be0",
                    borderRadius: 3,
                    // p: 4,
                    textAlign: "center",
                  }}
                >
                  <img
                    src="/newdashboard/Frame 1597881027.png"
                    alt="IELTS"
                    style={{ maxWidth: "100%", borderRadius: "12px" }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {/* Exam Pattern Section */}
          <Grid item xs={12}>
            {examPatterndata?.exam_pattern?.map((data) => (
              <Box sx={{ mt: 2 }}>
                <Typography
                  fontSize="24px"
                  color="#000000"
                  fontFamily="Inter"
                  fontWeight={400}
                  gutterBottom
                  sx={{ mt: 2 }}
                >
                  Exam Pattern{" "}
                  {data?.title ? (
                    <span style={{ color: "#444444" }}>({data?.title})</span>
                  ) : (
                    ""
                  )}
                </Typography>

                <Grid container spacing={3}>
                  {data?.sections?.map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={
                        data?.sections?.length === 1
                          ? 12
                          : data?.sections?.length === 2
                          ? 6
                          : data?.sections?.length === 3
                          ? 4
                          : data?.sections?.length === 4
                          ? 3
                          : 12
                      }
                      key={index}
                      mt={1}
                    >
                      <GlobalCard
                        height="100%"
                        textAlign="center"
                        hovershadowEffect={true}
                      >
                        <Typography
                          fontSize="20px"
                          color="#9D0385"
                          fontFamily="Inter"
                          fontWeight={500}
                        >
                          {item.module_name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {item.total_time}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          {item.question}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          {item.score_range}
                        </Typography>
                      </GlobalCard>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Grid>

          {["SAT", "GRE", "GMAT"].includes(testName) && (
            <Grid item xs={12}>
              <Typography
                fontSize="24px"
                color="#000000"
                fontFamily="Inter"
                fontWeight={400}
                mb={1}
              >
                {testTypeContent?.tipsTitle}
              </Typography>
              <GlobalCard>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      fontSize="20px"
                      color="#9D0385"
                      fontFamily="Inter"
                      fontWeight={400}
                      sx={{ mb: 3 }}
                    >
                      {testTypeContent?.titpsheading}
                    </Typography>

                    <Grid container spacing={2}>
                      {testTypeContent?.tips?.map((tip, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 1,
                            }}
                          >
                            <FiberManualRecordIcon
                              sx={{ fontSize: 8, mt: "2px", color: "#333" }}
                            />
                            <Typography
                              fontSize="14px"
                              color="#444444"
                              fontFamily="Inter"
                              fontWeight={400}
                            >
                              {tip}
                            </Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </GlobalCard>
            </Grid>
          )}

          {["TOEFL", "PTE", "IELTS", "SPOKEN ENGLISH"].includes(testName) && (
            <Grid item xs={12}>
              <Typography
                fontSize="24px"
                color="#000000"
                fontFamily="Inter"
                fontWeight={400}
                mb={1}
              >
                {testTypeContent?.tipsTitle}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <GlobalCard height="100%">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          fontSize="20px"
                          color="#9D0385"
                          fontFamily="Inter"
                          fontWeight={400}
                          sx={{ mb: 3 }}
                        >
                          {testTypeContent?.resourcesHeading}
                        </Typography>

                        <Grid container spacing={2}>
                          {testTypeContent?.resources?.map((tip, index) => (
                            <Grid item xs={12} sm={12} key={index}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: 1,
                                }}
                              >
                                <FiberManualRecordIcon
                                  sx={{ fontSize: 8, mt: "2px", color: "#333" }}
                                />
                                <Typography
                                  fontSize="14px"
                                  color="#444444"
                                  fontFamily="Inter"
                                  fontWeight={400}
                                >
                                  {tip}
                                </Typography>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </GlobalCard>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <GlobalCard height="100%">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          fontSize="20px"
                          color="#9D0385"
                          fontFamily="Inter"
                          fontWeight={400}
                          sx={{ mb: 3 }}
                        >
                          {testTypeContent?.titpsheading}
                        </Typography>

                        <Grid container spacing={2}>
                          {testTypeContent?.tips?.map((tip, index) => (
                            <Grid item xs={12} sm={12} key={index}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: 1,
                                }}
                              >
                                <FiberManualRecordIcon
                                  sx={{ fontSize: 8, mt: "2px", color: "#333" }}
                                />
                                <Typography
                                  fontSize="14px"
                                  color="#444444"
                                  fontFamily="Inter"
                                  fontWeight={400}
                                >
                                  {tip}
                                </Typography>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </GlobalCard>
                </Grid>
              </Grid>
            </Grid>
          )}

          {testName === "SPOKEN ENGLISH" && (
            <Grid item xs={12} mt={2}>
              <Typography
                fontSize="21px"
                color="#000000"
                fontFamily="Inter"
                fontWeight={400}
              >
                course structure
              </Typography>
              <Grid container spacing={3}>
                {testTypeContent?.course_structure?.map((item, index) => (
                  <Grid item xs={12} sm={12} md={4} key={index} mt={1}>
                    <GlobalCard
                      height="100%"
                      textAlign="center"
                      hovershadowEffect={true}
                    >
                      <Typography
                        fontSize="18px"
                        color="#9D0385"
                        fontFamily="Inter"
                        fontWeight={400}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        fontSize="12px"
                        color="#333333"
                        fontFamily="Inter"
                        fontWeight={400}
                        mt={1}
                      >
                        {item.features}
                      </Typography>
                    </GlobalCard>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} mt={2}>
            <Typography
              fontSize="24px"
              color="#000000"
              fontFamily="Inter"
              fontWeight={400}
            >
              Why choose Us ?
            </Typography>
            <Grid container spacing={3}>
              {features?.map((item, index) => (
                <Grid item xs={12} sm={12} md={4} key={index} mt={1}>
                  <GlobalCard
                    height="100%"
                    textAlign="center"
                    hovershadowEffect={true}
                  >
                    <Typography
                      fontSize="20px"
                      color="#9D0385"
                      fontFamily="Inter"
                      fontWeight={500}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      fontSize="14px"
                      color="#333333"
                      fontFamily="Inter"
                      fontWeight={400}
                      mt={1}
                    >
                      {item.description}
                    </Typography>
                  </GlobalCard>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            mt={2}
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
              },
            }}
          >
            <Testimonials />
          </Grid>

          <Grid
            item
            xs={12}
            mt={2}
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
              },
            }}
          >
           < DashboardBlogs/>
          </Grid>

          <Grid item xs={12}>
            <GlobalCard>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="24px"
                    color="#572575"
                    textAlign="center"
                  >
                    Frequently Ask Questions
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {testTypeContent?.faqs?.map(({ question, answer }, idx) => (
                    <Accordion
                      key={idx}
                      sx={{
                        boxShadow: "0 3px 6px rgba(75, 58, 120, 0.1)",
                        borderRadius: "12px",
                        mb: 2,
                        "&:before": { display: "none" }, // Remove default divider line
                        "& .MuiPaper-root": {
                          borderRadius: "12px",
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon sx={{ color: "#4b3a78" }} />
                        }
                        sx={{
                          bgcolor: "white",
                          fontWeight: 400,

                          color: "#222222",
                          fontFamily: "Inter",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            color: "#222222",
                            fontFamily: "Inter",
                            letterSpacing: "0px",
                            lineHeight: "100%",
                            verticalAlign: "middle",
                          }}
                        >
                          {question}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          bgcolor: "#fff",
                          color: "#6e6e85",
                          fontSize: "0.9rem",
                          fontFamily: "'Georgia', serif",
                        }}
                      >
                        {answer}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Grid>
              </Grid>
            </GlobalCard>
          </Grid>
        </Grid>
      </GlobalCard>

       <CustomPopup
        handleClose={handleCloseBookDemo}
        component={
          <BookDemoForm
            handleClose={handleCloseBookDemo}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            testId={testTypeId}
          />
        }
        open={openBookDemo}
        title="Book a demo session"
        titleColor="#000000"
        maxWidth="md"
        titleAlign="center"
      />

       <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            const
            text="Demo Session Booked !."
            subText="Your demo session has been booked. We’ve reserved your slot and shared the details with you."
            buttonTitle="View Demo"
            startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
